var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"erros-container"},[_c('h4',[_vm._v("Notas não incluidas no lote:")]),_c('v-spacer'),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.notasErro,"items-per-page":50}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }